import React, { useEffect, useState } from "react";
import {
  useGetProfilesQuery,
  useSortSeniorityMutation,
} from "../../redux/managementProfileApi";
import { MdEmail } from "react-icons/md";
import noImage from "../../asset/no image.png";
import { closestCenter, DndContext } from "@dnd-kit/core";
import {
  arrayMove,
  rectSortingStrategy,
  SortableContext,
  useSortable,
} from "@dnd-kit/sortable";
import { restrictToParentElement } from "@dnd-kit/modifiers";
import { RiDragMoveFill } from "react-icons/ri";
import { CSS } from "@dnd-kit/utilities";
import { toast } from "react-toastify";
import ButtonLoading from "../Button loading/ButtonLoading";

const SortManagementProfile = () => {
  const [selectedPostCategory, setSelectedPostCategory] = useState("");
  const { data, isLoading, isFetching } = useGetProfilesQuery(
    { postCategory: selectedPostCategory },
    {
      skip: !selectedPostCategory,
    },
  );
  const mangementProfiles = data?.profiles;
  const [sortSeniority, { isLoading: sortLoading }] = useSortSeniorityMutation(
    {},
  );
  const [profiles, setProfiles] = useState([]);
  const [originalProfiles, setOriginalProfiles] = useState([]);
  const [dragEnabled, setDragEnabled] = useState(true);

  const handleDragEnd = async ({ active, over }) => {
    if (!over || active.id === over.id) return;

    setProfiles((prev) => {
      const oldIndex = prev.findIndex((i) => i._id === active.id);
      const newIndex = prev.findIndex((i) => i._id === over.id);

      const newOrder = arrayMove(prev, oldIndex, newIndex);

      return newOrder;
    });
  };

  const isOrderChanged = () => {
    if (profiles.length !== originalProfiles.length) return true;

    return profiles.some(
      (profile, index) => profile._id !== originalProfiles[index]?._id,
    );
  };
  const postCategories = [
    "Chairman",
    "Director General",
    "Additional Director General",
    "Chief Planner",
    "Chief Engineer",
    "Director",
    "Deputy Director",
    "Assistant Director",
  ];

  const hasChanges = isOrderChanged();

  const handleReOrderSubmit = async () => {
    try {
      if (profiles.length === 0) {
        toast.error(
          "No profiles found. Please add profiles before reordering.",
        );
        return;
      }
      if (!isOrderChanged()) {
        toast.info("Order is already the same");
        setDragEnabled(false);
        return;
      }

      const profileData = profiles.map((profile, index) => ({
        id: profile._id,
        name: profile.fullName,
        seniority: index + 1,
      }));

      console.log("profileData", profileData);

      const response = await sortSeniority({
        profileData,
      }).unwrap();
      if (response.success) {
        toast.success(response.message);
        setOriginalProfiles(profiles);
      }
    } catch (error) {
      toast.error(error?.data?.message || error?.data?.error);
    }
  };

  useEffect(() => {
    if (Array.isArray(mangementProfiles) && mangementProfiles.length > 0) {
      setProfiles(mangementProfiles);
      setOriginalProfiles(mangementProfiles);
    } else {
      setProfiles([]);
      setOriginalProfiles([]);
    }
  }, [mangementProfiles]);

  return (
    <div className="flex flex-col lg:gap-10 md:gap-6 gap-4 bg-white rounded-xl lg:p-4 p-3 h-full lg:min-h-[calc(100vh-174px)] min-h-[calc(100vh-136px)] ">
      <div className="flex justify-between items-center">
        <p className="text-[#05004E] font-semibold lg:text-[1.8rem] md:text-[1.4rem] text-[1.2rem]">
          Sort Management Profile
        </p>
      </div>
      <div className="flex flex-col gap-10 w-full">
        <div className="flex flex-col gap-1 max-w-md mx-auto w-full">
          <label className="font-semibold text-[1.1rem] text-center capitalize text-[#151D48]">
            Please select the cartegory to sort the profile
          </label>
          <select
            name="postCategory"
            value={selectedPostCategory}
            onChange={(e) => setSelectedPostCategory(e.target.value)}
            className="w-full border border-[#D1D5DC]  text-[#737791] placeholder:text-[#0A0A0A80] outline-none lg:p-4 md:p-3 p-2 lg:rounded-xl rounded-lg"
          >
            {" "}
            <option value="">Select Post Category</option>
            {postCategories?.map((category, i) => (
              <option key={i} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        {isLoading || isFetching ? (
          <p className="text-center text-[#737791] mt-4">Loading profiles...</p>
        ) : profiles?.length > 0 ? (
          <div className=" flex flex-col gap-4">
            <div className="flex justify-end w-full">
              <button
                onClick={() => {
                  if (hasChanges) {
                    handleReOrderSubmit();
                  } else {
                    toast.info("Order is already the same");
                  }
                }}
                disabled={
                  sortLoading ||
                  profiles.length === 0 ||
                  isLoading ||
                  isFetching
                }
                className="lg:w-[12rem] md:w-[10rem] disabled:opacity-50 disabled:cursor-not-allowed w-max bg-[#00643b] text-center flex items-center gap-1.5 justify-center lg:py-3 md:py-2 md:px-0 px-2 py-1.5 lg:text-[1rem] md:text-[.9rem] text-[.75rem] md:rounded-xl rounded-lg font-medium text-white"
              >
                {sortLoading ? <ButtonLoading text="Saving..." /> : "Save"}
              </button>
            </div>
            <div
              className={`${dragEnabled && " border-2 border-[#151D48] bg-[#151D4833] py-4 px-2 rounded-2xl"}`}
            >
              <DndContext
                collisionDetection={closestCenter}
                modifiers={[restrictToParentElement]}
                onDragEnd={handleDragEnd}
                className="bg-amber-200 border border-amber-600"
              >
                <SortableContext
                  items={profiles.map((i) => i._id)}
                  strategy={rectSortingStrategy}
                >
                  <div className="grid 2xl:grid-cols-5 xl:grid-cols-4 lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 w-full justify-items-center items-stretch">
                    {profiles.map((item, i) => (
                      <SortableGalleryItem
                        key={item._id}
                        item={item}
                        dragEnabled={dragEnabled}
                      />
                    ))}
                  </div>
                </SortableContext>
              </DndContext>
            </div>
          </div>
        ) : (
          <p className="text-center text-[#737791] mt-4">
            No profiles found for the selected category.
          </p>
        )}
      </div>
    </div>
  );
};

const SortableGalleryItem = ({ item, dragEnabled }) => {
  const { setNodeRef, attributes, listeners, transform, transition } =
    useSortable({
      id: item._id,
      disabled: !dragEnabled,
    });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="w-full relative  group overflow-hidden rounded-xl"
    >
      <div
        {...(dragEnabled ? listeners : {})}
        {...attributes}
        className={`absolute  top-2 left-2 z-20 bg-white p-2 rounded-lg
          ${dragEnabled ? "cursor-grab flex" : "cursor-not-allowed opacity-50 hidden"}
        `}
      >
        <RiDragMoveFill className="text-[#151D48] size-5" />
      </div>

      <div className="w-full relative bg-[#DEE9E4] group hover:bg-[#00643b] p-4 rounded-2xl ">
        <img
          src={
            item?.profileImage?.imageUrl
              ? item?.profileImage?.imageUrl
              : noImage
          }
          className="rounded-xl w-full aspect-[1/1.2] object-cover"
          alt=""
        />
        <div className="mt-8 text-center relative">
          <a
            href={`mailto:${item?.email}`}
            className="absolute bg-[#00643b] group-hover:bg-[#fff] py-1.5 px-5 rounded-full text-white group-hover:text-[#00643b] top-[-48px] left-1/2 transform -translate-x-1/2"
          >
            <MdEmail className="size-5" />
          </a>
          <h1 className="text-[.9rem] font-semibold group-hover:text-[#fff]">
            {item?.fullName}
          </h1>
          <p className="text-[.6rem] text-[#343434] group-hover:text-[#fff] font-semibold">
            {item?.position}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SortManagementProfile;
